module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABCSURBVHgBLYtbDcAgEATnWgM1QFJpWMABDlAGSAAJKOA4Avux2UdGXM0eJAFDmFFcLU3h52g8Zt8t6Bk0WOj7fQ1ZVpERhjBhFWEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/activeDot.png
// module id = 1783
// module chunks = 0